import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Skeleton, Text } from '@mantine/core';
import { fetchQuestionnairesByEvent, newQuestionnaire } from '../../../Service/restapi/questionnaireService';
import { EventContext } from '../../../Service/Context/EventContext';
import SelectQuestionnaireTemplateModal from '../../Settings/QuestionnaireTemplate/SelectQuestionnaireTemplateModal';
import { useModalState } from '../../Dialogs';
import PanePaper from '../../PanePaper';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { ConstantS } from '../../../Service/ConstantS';
import { MixpanelS } from '../../../Service/MixpanelS';
import BookitupTutorialIcon from '../../../Atoms/BookitupTutorialIcon';
import QuestionnairePaneTable from './QuestionnairePaneTable';

const QuestionnairePane = () => {
  const [questionnaires, setQuestionnaires] = useState([]);
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { event } = useContext(EventContext);
  const { show, toggle } = useModalState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { customerId } = event ?? {};

  const load = useCallback(async () => {
    setLoading(true);

    try {
      const response = await fetchQuestionnairesByEvent(eventId);
      if (response.ok) {
        setQuestionnaires(await response.json());
      } else {
        console.error('could not load questionnaires');
      }
    } catch (error) {
      console.error({ error });
      console.error('could not load questionnaires');
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    if (eventId) {
      load();
    }
  }, [eventId, load]);

  function addNewQuestionnaire(templateName) {
    setLoading(true);
    newQuestionnaire(eventId, customerId, templateName)
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((questionnaire) => {
            MixpanelS.track(ConstantS.TrackingEvents.QuestionnaireCreated);
            navigate(`/events/${eventId}/questionnaires/${questionnaire.id}`);
          });
        } else {
          console.error('could not create new questionnaire');
        }
      })
      .catch((error) => {
        console.error('could not create new questionnaire');
        console.error({ error });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <PanePaper
      title="common.questionnaires"
      tooltip="licence.event.questionnaires-offline.pane"
      rightSection={
        <>
          <BookitupTutorialIcon
            videoUrl={'https://app.bookitup.de/academy/channels/event-details?episodeId=zgkqf33ydb'}
            name={'CreateQuestionnaire'}
          />
          <BookitupAddIcon onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.FRAGEBOGEN_USAGE, toggle)} />
        </>
      }
    >
      <div>
        {loading ? (
          <div>
            {Array.from(Array(3)).map(() => (
              <Skeleton key={Math.random()} radius="md" height={25} width="100%" mb={10} />
            ))}
          </div>
        ) : (
          <div>
            {questionnaires.length === 0 ? (
              <Text italic color="dimmed" size="xs" weight="lighter">
                Noch nichts hinzugefügt.
              </Text>
            ) : (
              <QuestionnairePaneTable questionnaires={questionnaires} reload={load} />
            )}
          </div>
        )}
      </div>
      <SelectQuestionnaireTemplateModal isLoading={loading} open={show} toggle={toggle} finish={addNewQuestionnaire} />
    </PanePaper>
  );
};

export default QuestionnairePane;
